import { render, staticRenderFns } from "./CommonMenuAside.vue?vue&type=template&id=3d248278&scoped=true"
import script from "./CommonMenuAside.vue?vue&type=script&lang=js"
export * from "./CommonMenuAside.vue?vue&type=script&lang=js"
import style0 from "./CommonMenuAside.vue?vue&type=style&index=0&id=3d248278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d248278",
  null
  
)

export default component.exports